import React, { useState, useEffect } from 'react';
import {
  Box, Autocomplete, TextField, IconButton, Typography, Grid, ListSubheader, Chip 
} from '@mui/material';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import axios from 'axios';
import { refreshUserTokens } from '../tokenHandling'
import { useNavigate } from 'react-router-dom';

function Mockups(props) {
  const [images, setImages] = useState([]);
  const [image_u, setImageM] = useState('');
  const [prompt_t, setPromptM] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  //const [selectedProducts, setSelectedProducts] = useState({});
  const [responseData, setResponseData] = useState(null); // Added to store response data
  const [finalList, setFinalList] = useState([]);
  const [dalle_image_mockup, setDalleImageMockup] = useState('');
  const [loading, setLoading] = useState(false);
  const [randomGifUrl, setRandomGifUrl] = useState('');
  const [isSwitchingToPublish, setIsSwitchingToPublish] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedProductTypes, setSelectedProductTypes] = useState(null);
  const [productOptions, setProductOptions] = useState([]);
  const navigate = useNavigate();
  

  useEffect(() => {
    const fetchProductOptions = async () => {
      try {
        console.log("Trying to fetch product options");
        const response = await axios.get(process.env.REACT_APP_GET_PRODUCT_LIST);
        if (response.status === 200) {
          console.log('product options data.product_categories is', response.data.product_categories);
          // Transform the product categories into the desired format
          const formattedProductOptions = Object.entries(response.data.product_categories).map(([key, value]) => ({
            label: key, // The key is used as the label
            id: key,   // The key is also used as the id
            price: `$${value.toFixed(2)}` // Format the price as a string with two decimal places
          }));
          setProductOptions(formattedProductOptions);
        } else {
          console.log('Error getting product list');
        }
      } catch (error) {
        console.error('Error getting product list:', error);
      }
    };
    fetchProductOptions();
  }, []);
 

  const handleProductTypeChange = (event, newValue) => {
    // Ensure uniqueness based on the 'id' property of the products
    const unique = Array.from(new Map(newValue.map(item => [item['id'], item])).values());
    setSelectedProductTypes(unique);
  };


  useEffect(() => {
    if (props.mockupData.image_url && props.mockupData.prompt) {
      console.log('Received image URL:', props.mockupData.image_url);
      console.log('Received prompt:', props.mockupData.prompt);
      setImageM(props.mockupData.image_url);
      setPromptM(props.mockupData.prompt);
      setDalleImageMockup(props.mockupData.dalle_image)
    }
  }, [props.mockupData]);

  const handleGenerate = async () => {
    console.log("CHECK HERE: ");
    const productTypeLabel = selectedProductTypes ? selectedProductTypes.label : null;
    console.log("SELECTED PRODUCT TYPE LABEL:");
    console.log(productTypeLabel); // This will print the label of the selected product type
    setSelectedCategory(productTypeLabel);
    setIsSwitchingToPublish(false);
    setLoading(true);
  
    const myaccessToken = await refreshUserTokens();
    
    const data = {
      image_u: image_u,
      prompt_t: prompt_t,
      selectedCategories: productTypeLabel ? [productTypeLabel] : [], // Wrap label in an array if it exists
      accessToken: myaccessToken,
    };
    console.log("data", data);
    console.log("hey", process.env.REACT_APP_MOCKY_API);
    try {
      const response = await axios.post(process.env.REACT_APP_MOCKY_API, data);
      if (response.status === 200) {
        console.log('Data sent successfully');
        console.log(response.data.dic);
        setResponseData(response.data.dic);
        const newImages = response.data.dic.map(item => ({
          id: item.variant_id,
          imgPath: item.url,
          caption: item.prompt + ' - ' + item.color
        }));
        console.log(newImages);
        setImages(newImages);
      } else {
        console.error('Failed to send data to the server');
      }
    } catch (error) {
      console.error('Error sending data to the server:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleProductSelection = (id) => {
    setSelectedProducts((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const getTotalSelected = () => {
    return Object.values(selectedProducts).filter((selected) => selected).length;
  };


  const selectedImages = images.filter(image => selectedProducts[image.id]);
  
  const onNextButtonClick = async () => {
    setLoading(true);
    setIsSwitchingToPublish(true);
    const filteredResponseData = responseData && responseData.filter(responseItem => 
      selectedProducts[responseItem.variant_id] // Ensure the product is selected
    );
  
  
    try {
      const response = await axios.post(process.env.REACT_APP_NAMEOR, {
        data: filteredResponseData, 
        product: selectedProductTypes?.label, 
        image: props.mockupData.dalle_image
      });
  
      if (response.status === 200) {
        console.log("HHH");
        console.log(selectedCategory);
        const x = selectedCategory;

        setFinalList(response.data.final_list);
        setLoading(false);
        navigate('/publish', { state: {
          selectedImages: images.filter(image => selectedProducts[image.id]),
          mockupResponseData: responseData,
          finalList: response.data.final_list,
          product: x,
        }});
      }
    } catch (error) {
      console.error('Error sending data:', error);
      setLoading(false);
    }
  };

  // console.log(responseData);
  // console.log(selectedImages);
  return (
    <Box sx={{marginTop:'50px',}}>
      {loading ? (
      <Box sx={{
        marginTop:'50px',
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center'
      }}>
        <img src={'/logo.png'} alt="Loading..." className="dancingImage" />
        <Typography 
      variant='h6' 
      sx={{ 
        mt: '20px', // Directly sets the top margin to 20px
        fontWeight: 'bold' // This makes the font weight bold.
      }}>
      {isSwitchingToPublish ? "Generating titles and descriptions..." : "Generating mockups..."}
    </Typography>
      </Box>
    ) :(
      <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '80vh',
        marginBottom: '20px',
      }}
    >
      
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          p: 1,
          width: '100%',
          borderRadius: '10px',
          padding: '20px',
        }}
      >
        <Autocomplete
  id="product-type-autocomplete"
  options={productOptions} // Assuming productOptions is your array of options
  getOptionLabel={(option) => option.label}
  renderInput={(params) => <TextField {...params} placeholder="Select a product type..." />}
  value={selectedProductTypes}
  onChange={(event, newValue) => {
    setSelectedProductTypes(newValue);
  }}
  renderOption={(props, option) => (
    <li {...props}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        {option.label}
        <Typography variant="body2" sx={{ marginLeft: 'auto' }}>{option.price}</Typography>
      </Box>
    </li>
  )}
  ListboxProps={{
    sx: {
      '& ul': {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
    renderGroup: (params) => [
      <ListSubheader key="1" component="div" disableSticky sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        bgcolor: 'background.paper', 
        borderBottom: '1px solid rgba(0,0,0,.1)', 
        typography: 'subtitle1', 
        px: 2 
      }}>
        <span>Products</span> 
        <span style={{ marginLeft: 'auto' }}>Price:</span>
      </ListSubheader>,
      params.children,
    ],
  }}
  groupBy={() => 'Products:'}
  sx={{
    width: '100%',
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#F5F5F5',
      '& fieldset': {
        borderColor: 'transparent',
      },
      '&:hover fieldset': {
        borderColor: 'transparent',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'transparent',
      },
    },
  }}
/>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minWidth: '100px',
            height: '100%'
          }}
        >
          <IconButton
            aria-label="generate"
            onClick={handleGenerate}
            sx={{
              backgroundColor: '#ff4c15ff',
              color: '#FFFFFF',
              '&:hover': {
                backgroundColor: '#e2400f',
              },
              borderRadius: '10px',
              minHeight: '50px',
              width: '100%',
            }}
          >
            <AutoAwesomeRoundedIcon />
          </IconButton>
        </Box>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          marginTop: '20px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width:'100%',
          margin: 'auto',
        }}
      >
        <Box sx={{ height: '70vh', overflowY: 'auto', padding:'20px', }}>
        <Grid container spacing={5} justifyContent="center" alignItems="center" sx={{marginBottom:'200px'}}>
          {images.map((image) => (
            <Grid item xs={3} key={image.id} onClick={() => toggleProductSelection(image.id)}>
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '20px',
                  border: selectedProducts[image.id] ? '3px solid #ff4c15' : 'none',
                  '&:hover': {
                    boxShadow: '0 0 11px rgba(33,33,33,.2)',
                  },
                  display: 'flex', // Add this to ensure the image is centered if that's your intention
                  justifyContent: 'center',
                  alignItems: 'center',
                  overflow: 'hidden', // Ensures the image does not spill outside the border radius
                }}
              >
                <img
                  src={image.imgPath}
                  alt={image.caption}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
        </Box>
        {getTotalSelected() > 0 && (
          <Box
            sx={{
              display: 'flex',
              position: 'fixed',
              bottom: 70,
              alignItems: 'center',
              width: '20%',
              justifyContent: 'space-between',
              backgroundColor: 'rgba(255, 255, 255, 1)',
              padding: '20px',
              borderRadius: '10px',
              color: '#000',
              backdropFilter: 'blur(20px)',
              boxShadow: '0 4px 50px rgba(0, 0, 0, 0.5)',
            }}
          >
            <Typography variant="h7" sx={{ fontWeight: 'bold' }}>Products Selected: {getTotalSelected()}</Typography>
            <IconButton
              aria-label="next"
              onClick= {onNextButtonClick} //{() => props.onChangeToPublish()}
              sx={{
                backgroundColor: '#ff4c15',
                '&:hover': {
                  backgroundColor: '#e2400f',
                },
                color: '#FFFFFF',
                borderRadius: '10px',
                height: '50px',
                width: '50px',
              }}
            >
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
        )}
      </Box>
    </Box>
    )}
    </Box>
    
  );
}

export default Mockups;